import ForgotPassword from 'components/Login/ForgotPassword';
import NonAuthHeader from 'components/shared/Header';
import React from 'react';

const ForgotPasswordPage = () => {
  return <>
    <>
      <NonAuthHeader />
      <ForgotPassword />
    </>
  </>
}

export default ForgotPasswordPage;
